import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { LockInitialWidthDirective } from '../../../../directives/lock-initial-width.directive';

@Component({
  selector: 'app-poc-container-infestation-rate',
  standalone: true,
  imports: [
    SelectModule,
    CommonModule,
    FormsModule,
    ToggleSwitchModule,
    InputNumberModule,
    FloatLabelModule,
    CardModule,
    LockInitialWidthDirective,
    TooltipModule
  ],
  templateUrl: './poc-container-infestation-rate.component.html'
})
export class PocContainerInfestationRateComponent {
  @Input() distinctContainers: any[] = [];
  @Input() isDisabled: boolean = false;
  @Input() editingInstance: boolean = false;
  @Input() editingMode!: string;
  @Output() public containerItemChangeEvent = new EventEmitter<any>();

  containerItem = { id: null, standard: true, quantityPerContainer: 0 };
  selectedContainer: any;
  quantityPerContainer: number = 0;
  standardTooltipText: string =
    'By default, the insectary team will use their standard process to fill your order. If you would like to customize your request, turn off the "Standard" and enter your custom amount below.';

  onChangeContainer(): void {
    this.containerItem.standard = true;
    this.containerItem.quantityPerContainer = 0;
    this.updateVariables();
    // afterRender(() => this.emitContainerItem());
  }

  emitContainerItem(): any {
    this.containerItemChangeEvent.emit(this.containerItem);
  }

  onStandardToggle(event: any): void {
    if (event.checked) {
      this.containerItem.quantityPerContainer = this.selectedContainer.infestationRate ?? 0;
    } else {
      this.containerItem.quantityPerContainer = this.quantityPerContainer ?? 0;
    }
    // afterRender(() => this.emitContainerItem());
  }

  private updateVariables() {
    this.selectedContainer = this.distinctContainers.find((container: any) => container.id === this.containerItem.id);

    if (this.selectedContainer) {
      this.quantityPerContainer = this.selectedContainer.infestationRate ?? 0;
      this.containerItem.quantityPerContainer = this.selectedContainer.infestationRate ?? 0;

      // this.quantityPerContainer =
      //   this.editingOrderItemContainerInfestation && this.editingOrderItemContainerInfestation.infestationRateQuantity !== null
      //     ? this.editingOrderItemContainerInfestation.infestationRateQuantity
      //     : (this.selectedContainer.infestationRate ?? 0);
      // this.containerItem.quantityPerContainer =
      //   this.editingOrderItemContainerInfestation && this.editingOrderItemContainerInfestation.infestationRateQuantity !== null
      //     ? this.editingOrderItemContainerInfestation.infestationRateQuantity
      //     : (this.selectedContainer.infestationRate ?? 0);
      // if (this.editingOrderItemContainerInfestation && this.editingOrderItemContainerInfestation.standardInfestationRate !== null) {
      //   const newStandardValue =
      //     this.editingOrderItemContainerInfestation.standardInfestationRate === 1 ||
      //     this.editingOrderItemContainerInfestation.standardInfestationRate === true;
      //   this.containerItem.standard = newStandardValue;
      // }
    } else {
      this.quantityPerContainer = 0;
      this.containerItem.quantityPerContainer = 0;
    }
  }
}
